








































































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'
import TicketingProcessGantt from '@/components/ticketing/TicketingProcessGantt.vue'
import { TranslateResult } from 'vue-i18n'
import { hexToRgba } from '@/services/hex-to-rgba'
import { SnackbarStateEnum } from '@/types/enums'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  tableHeight: string
  loading: boolean
  loadingSave: boolean
  isEditMode: boolean

  employee: any | null
  work: any | null
  budget: any | null
  date: any | null
  description: any | null

  stepsList: any[]
  selectedItem: any | null

}

export default Vue.extend({
  name: 'TicketingSteps',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    TicketingProcessGantt
  },

  props: {
    ticketId: Number
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      tableHeight: '',
      loading: false,
      loadingSave: false,
      isEditMode: false,

      employee: null,
      work: null,
      budget: null,
      date: null,
      description: null,

      stepsList: [],
      selectedItem: null

    }
  },

  watch: {
    ticketId (newVal: number): void {
      if(newVal) {

      }
    }
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    rowClick(event: any): void {
      this.selectedItem = event.data
      this.employee = this.selectedItem.employee
      this.work = this.selectedItem.workDescription
      this.budget = this.selectedItem.budgetHours
      this.date = this.selectedItem.date
      this.description = this.selectedItem.description
    },

    rowDblClick(event: any): void {
      this.selectedItem = event.data
      this.setData()
    },

    onEditStepClick (): void {
      this.isEditMode = true
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onSaveButtonClick (): void {

    },

    onCancelClick (): void {
      this.isEditMode = false
      this.setData()
    },

    setData (): void {
      const form: any = this.$refs['form']
      form.resetValidation()
      if(this.selectedItem) {
        this.employee = this.selectedItem.employee
        this.work = this.selectedItem.workDescription
        this.budget = this.selectedItem.budgetHours
        this.date = this.selectedItem.date
        this.description = this.selectedItem.description
      } else {
        this.employee = null
        this.work = null
        this.budget = null
        this.date = null
        this.description = null
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 172px - ${height}px - 60px - 312px)`
        } else {
          this.tableHeight = 'height: 300px'
        }
      } else {
        this.tableHeight = 'height: 300px'
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted (): void {
    this.stepsList = [
      {id: 1, employeeName: 'Eva Cronauer', workDescription: '', budgetHours: '0.00', date: '29.01.2024 10:00', completed: '29.01.2024 10:00', description: 'Erledigt' },
      {id: 2, employeeName: 'Eva Cronauer', workDescription: '', budgetHours: '0.00', date: '10.02.2024 10:00', completed: '29.01.2024 10:00', description: 'Erledigt' },
      {id: 3, employeeName: 'Eva Cronauer', workDescription: '', budgetHours: '0.00', date: '18.02.2024 10:00', completed: '29.01.2024 10:00', description: 'Zugeordnet (Mit Mail)' },
      {id: 4, employeeName: 'Eva Cronauer', workDescription: '', budgetHours: '0.00', date: '19.02.2024 10:00', completed: '29.01.2024 10:00', description: 'Zugeordnet (Mit Mail)' },
      {id: 5, employeeName: 'Eva Cronauer', workDescription: '', budgetHours: '0.00', date: '20.02.2024 10:00', completed: '29.01.2024 10:00', description: 'Zugeordnet (Mit Mail)' },
    ]
  }
})
